// extracted by mini-css-extract-plugin
module.exports = {"policy":"Policy_policy__1TeXC","title":"Policy_title__1XSYN","center":"Policy_center__3cxR_","msg":"Policy_msg__3i_hW","keynote":"Policy_keynote__2OP_R"};